import { useEffect, useState } from "react";
import { api } from "../api";
import { useT } from "../i18n";

/** Sign-in: the central login (Zitadel, organisation `partners`) on staging; an email code in development. */
export function SignIn() {
  const t = useT();
  const [auth, setAuth] = useState<string>();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string>();
  useEffect(() => { void api<{ auth: string }>("/session").then((s) => setAuth(s.auth)); }, []);
  return (
    <div className="auth-page" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", padding: "16px" }}>
      <div className="card" style={{ width: "min(420px,100%)" }}>
        <div className="brand" style={{ marginBottom: "1rem" }}><b style={{ fontSize: "1.4rem" }}>The Station</b><br /><span className="muted">{t("brand.sub")}</span></div>
        <h2 style={{ marginBottom: "1rem" }}>{t("signin.title")}</h2>
        {auth === "zitadel" ? <a className="btn ink" href="/auth/login">{t("signin.central")}</a> : (
          <form className="mform" onSubmit={(e) => { e.preventDefault(); setErr(undefined); if (!sent) api("/auth/code", { body: { email } }).then(() => setSent(true), (x: Error) => setErr(x.message)); else api("/auth/verify", { body: { email, code } }).then(() => location.reload(), (x: Error) => setErr(x.message)); }}>
            <label className="f">{t("signin.email")}<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} disabled={sent} autoComplete="email" /></label>
            {sent ? <label className="f">{t("signin.code")}<input required inputMode="numeric" pattern="\d{6}" value={code} onChange={(e) => setCode(e.target.value)} autoFocus /></label> : null}
            {err ? <p className="muted" role="alert">{err}</p> : null}
            <button className="btn ink" type="submit">{sent ? t("signin.verify") : t("signin.send")}</button>
          </form>
        )}
        <p style={{ marginTop: "1rem" }}><a href="/join">{t("signin.join")}</a></p>
      </div>
    </div>
  );
}
